export const GETREQUESTS = "GETREQUESTS"

export const GETMYREQUESTS = "GETMYREQUESTS"
export const GETMYRECIVEDREQUEST = "GETMYRECIVEDREQUEST"